module.exports = __webpack_public_path__ + "static/media/sagomacacciatore.9f572d1f.png";